import ChatFlowDashboard from 'components/powerChatFlow/containers/powerChatFlow';
export const SettingsChatEditFlowView = ChatFlowDashboard;
